import { ANNOTATION_FIELD_CONFIG, AnnotationFieldType } from '@/constants/annotation';
import { AnnotationTemplateField } from '@/graphql/codegen/graphql';
import { WithMode, renameField, useTemplate } from '@/stores/template';
import { Input } from '@skand/ui';
import { RefObject } from 'react';

export const Name = ({
  field,
  handleRef,
}: {
  field: WithMode<AnnotationTemplateField>;
  handleRef?: RefObject<HTMLDivElement>;
}) => {
  const templateMode = useTemplate(state => state.mode);

  const getPlaceholder = (type: string | undefined | null) => {
    if (!type || type.length === 0) return '';
    return ANNOTATION_FIELD_CONFIG[type as AnnotationFieldType]?.placeholder || ' ';
  };

  return (
    <div className="min-h-[36px] flex items-center">
      {templateMode !== 'view' && (
        <div
          className="i-skand-reorder mr-3 cursor-grab color-neutral-400 hover:color-primary-400"
          ref={handleRef}
        />
      )}

      <div className="mr-3 flex-1">
        <Input
          onChange={text => renameField(field, text)}
          placeholder={getPlaceholder(field.type)}
          value={field.name ?? ''}
        />
      </div>
    </div>
  );
};
